import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DateRangeService} from '../../core/services/date-range.service';
import {MatDialog} from '@angular/material/dialog';
import {MatDateRangeDialogComponent} from './mat-date-range-dialog/mat-date-range-dialog.component';
import { MatOptionSelectionChange, MatOption } from '@angular/material/core';
import { MatSelectChange, MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatFormFieldFix } from '../../editors/mat-form-field/mat-form-field-fix';
import { MatFormField, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-mat-date-range',
    template: `
    <mat-form-field appearance="outline" hideRequiredMarker="true" style="width: 170px;" class="no-hint">
      <mat-icon matPrefix>today</mat-icon>
      <mat-select [value]="selectedDateRange" (selectionChange)="onSelectionChange($event)" [matTooltip]="selectedDateRange.title">
        <mat-select-trigger>
          {{selectedDateRange.title}}
        </mat-select-trigger>
        <mat-option *ngFor="let item of dateRangeService.dateRanges" [value]="item" (onSelectionChange)="onOptionSelectionChange($event)"
                    (click)="onSelectionClicked($event)">
          {{item.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
    styles: [
        ''
    ],
    standalone: true,
    imports: [MatFormFieldFix, MatFormField, MatIcon, MatPrefix, MatSelect, MatTooltip, MatSelectTrigger, NgFor, MatOption]
})
export class MatDateRangeComponent implements OnInit {

  @Output() onDateRangeSelected = new EventEmitter<any>();

  selectedDateRange: any;
  lastSelectedOptionItem: any;

  constructor(public dateRangeService: DateRangeService,
              public dialog: MatDialog) {
  }

  ngOnInit() {
    this.selectedDateRange = this.dateRangeService.selectedDateRange;

    this.dateRangeService.selectedDateRangeSubject.subscribe((newDateRange) => {
      this.selectedDateRange = newDateRange;
    });
  }

  onDateRangeChange(selectedItem) {
    if (selectedItem.action === 99) {
      this.showDateRangeDialog(selectedItem);
    } else {
      this.dateRangeService.onDateRangeChange(selectedItem);
      this.selectedDateRange = this.dateRangeService.selectedDateRange;
      this.onDateRangeSelected.emit({
        start: this.dateRangeService.rangeStartDate,
        end: this.dateRangeService.rangeEndDate
      });
    }
  }

  showDateRangeDialog(dateRangeType: any) {
    console.log('open filter dialog');
    const dialogRef = this.dialog.open(MatDateRangeDialogComponent, {
      width: '300px',
      data: {
        startDate: this.dateRangeService.rangeStartDate,
        endDate: this.dateRangeService.rangeEndDate
      }
    });

    dialogRef.afterClosed().subscribe(async (result: { startDate: Date, endDate: Date }) => {
      if (result) {
        this.dateRangeService.onDateRangeChange(dateRangeType, true);
        this.dateRangeService.setCustomRange(result.startDate, result.endDate);

        this.selectedDateRange = this.dateRangeService.selectedDateRange;
        console.log(this.dateRangeService.selectedDateRange);

        this.onDateRangeSelected.emit({
          start: this.dateRangeService.rangeStartDate,
          end: this.dateRangeService.rangeEndDate
        });
      }
    });
  }

  onOptionSelectionChange(option: MatOptionSelectionChange) {
    const selectedItem = option.source.value;
    console.log('onOptionChanged', selectedItem);
    this.lastSelectedOptionItem = selectedItem;
  }

  onSelectionChange(option: MatSelectChange) {
    this.selectedDateRange = option.source.value;
    console.log('onSelectionChange', this.selectedDateRange);
    this.onDateRangeChange(this.selectedDateRange);
  }

  onSelectionClicked($event: MouseEvent) {
    console.log('onSelectionClicked', $event);
    if (this.selectedDateRange.action === this.lastSelectedOptionItem.action) {
     if (this.lastSelectedOptionItem.action === 99) {
       this.onDateRangeChange(this.lastSelectedOptionItem);
     }
   }
  }
}
